'use strict';

var angularModule = angular.module('t2g.common.data-access.caldav-sync', []);

module.exports = angularModule;

angularModule.factory('CalDavResource', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/v2/calendarApi/:action/:provider/:user';

  var resource = $resource(
    resourceUrl,
    {},
    {
      getList: { method: 'GET', params: { action: 'list' } },
      getServices: { method: 'GET', params: { action: 'bookingtypes' } },
      linkService: { method: 'POST', params: { action: 'link', provider: 'upsert' } },
      unlinkService: { method: 'POST', params: { action: 'link', provider: 'delete' } },
      registerCalDav: { method: 'POST', params: { action: 'register', provider: 'caldav' } },
      delete: { method: 'POST', params: { action: 'caldav', provider: 'delete' } },
      discover: { method: 'GET', isArray: true, params: { action: 'discover' } },
      sync: { method: 'GET', params: { action: 'sync' } },
      getDiscoveredCalendars: {
        method: 'GET',
        isArray: true,
        params: { action: 'discovered-calendars' },
      },
      removeCalendars: { method: 'POST', params: { action: 'calendar', provider: 'delete' } },
    },
  );

  return resource;
});

angularModule.factory('CalDavDA', function($q, CalDavResource, LoadingIndicatorService) {
  return {
    getList: getList,
    getServices: getServices,
    linkService: linkService,
    unlinkService: unlinkService,
    registerCalDav: registerCalDav,
    disconnectProvider: disconnectProvider,
    discoverProvider: discoverProvider,
    sync: sync,
    getDiscoveredCalendars: getDiscoveredCalendars,
    removeCalendars: removeCalendars,
  };

  function getList() {
    LoadingIndicatorService.show();

    return CalDavResource.getList().$promise.then(
      function(response) {
        LoadingIndicatorService.hide();
        return response;
      },
      function(response) {
        LoadingIndicatorService.hide();
        return response.data;
      },
    );
  }

  function getServices() {
    LoadingIndicatorService.show();

    return CalDavResource.getServices().$promise.then(
      function(response) {
        LoadingIndicatorService.hide();
        return response;
      },
      function(response) {
        LoadingIndicatorService.hide();
        return response.data;
      },
    );
  }

  function registerCalDav(body) {
    LoadingIndicatorService.show();

    return CalDavResource.registerCalDav(body).$promise.then(
      function(response) {
        LoadingIndicatorService.hide();
        return response;
      },
      function(response) {
        LoadingIndicatorService.hide();
        return $q.reject(response.data);
      },
    );
  }

  function linkService(serviceId, calendarName) {
    LoadingIndicatorService.show();

    return CalDavResource.linkService({
      service_id: serviceId,
      calendar_name: calendarName,
    }).$promise.then(
      function(response) {
        LoadingIndicatorService.hide();
        return response;
      },
      function(response) {
        LoadingIndicatorService.hide();
        return $q.reject(response.data);
      },
    );
  }

  function unlinkService(serviceId) {
    LoadingIndicatorService.show();

    return CalDavResource.unlinkService({
      service_id: serviceId,
    }).$promise.then(
      function(response) {
        LoadingIndicatorService.hide();
        return response;
      },
      function(response) {
        LoadingIndicatorService.hide();
        return $q.reject(response.data);
      },
    );
  }

  function disconnectProvider(providerName) {
    LoadingIndicatorService.show();

    return CalDavResource.delete({
      provider_name: providerName,
    }).$promise.then(
      function(response) {
        LoadingIndicatorService.hide();
        return response;
      },
      function(response) {
        LoadingIndicatorService.hide();
        return $q.reject(response.data);
      },
    );
  }

  function discoverProvider(providerName) {
    LoadingIndicatorService.show();

    return CalDavResource.discover({
      provider: providerName,
    }).$promise.then(
      function(response) {
        LoadingIndicatorService.hide();
        return response;
      },
      function(response) {
        LoadingIndicatorService.hide();
        return $q.reject(response);
      },
    );
  }

  function sync(providerName) {
    LoadingIndicatorService.show();

    return CalDavResource.sync({
      provider: providerName || 'syncall',
    }).$promise.then(
      function(response) {
        LoadingIndicatorService.hide();
        return response;
      },
      function(response) {
        LoadingIndicatorService.hide();
        return $q.reject(response);
      },
    );
  }

  function getDiscoveredCalendars(providerName) {
    LoadingIndicatorService.show();

    return CalDavResource.getDiscoveredCalendars({
      provider: providerName,
    }).$promise.then(
      function(response) {
        LoadingIndicatorService.hide();
        return response;
      },
      function(response) {
        LoadingIndicatorService.hide();
        return $q.reject(response);
      },
    );
  }

  function removeCalendars(calendarsURLs) {
    LoadingIndicatorService.show();

    return CalDavResource.removeCalendars({
      calendars: calendarsURLs,
    }).$promise.then(
      function(response) {
        LoadingIndicatorService.hide();
        return response;
      },
      function(response) {
        LoadingIndicatorService.hide();
        return $q.reject(response);
      },
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/common/data-access/caldav-sync.js